import { OrgAdminConstants } from '../../../_constants';

const initialState = { changeMemberLevelLoading: true, data: '', error: false };

export function changeMemberLevelReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_CHANGE_MEMBER_LEVEL:
            return {
                changeMemberLevelLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_CHANGE_MEMBER_LEVEL:
            return {
                changeMemberLevelLoading: false,
                data: action.changeMemberLevel,
                error: false
            };
        case OrgAdminConstants.CHANGE_MEMBER_LEVEL_ERROR:
            return {
                changeMemberLevelLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/MemberLevel/changeMemberLevel.reducer.js